import goal1 from "~/assets/icons/video.svg";
import goal2 from "~/assets/icons/pills.svg";
import goal3 from "~/assets/icons/call.svg";

export const achieveData = [
  {
    id: 1,
    icon: goal1,
    text: "Initial Consultation",
    subText: "Tell us about yourself and your weight loss goals so that we can create the best plan for you"
  },
  {
    id: 2,
    icon: goal2,
    text: "Treatment plan",
    subText: "Pick up your prescription from a nearby pharmacy. Plus, get a customized meal and fitness plan tailored to your goals"
  },
  {
    id: 3,
    icon: goal3,
    text: "Active Support",
    subText: "We'll check in monthly to track your progress and answer any questions you have"
  },
];
